/**
 * Resolve a driver from their uniqueId.
 * @param {string|null} driverUniqueId - From position.attributes.driverUniqueId
 * @param {Object} driversMap - Redux drivers.items keyed by id
 * @returns {{ id: number|null, name: string|null }}
 */
export function resolveDriver(driverUniqueId, driversMap) {
  if (!driverUniqueId) return { id: null, name: null };
  const driver = Object.values(driversMap).find((d) => d.uniqueId === driverUniqueId);
  return driver ? { id: driver.id, name: driver.name } : { id: null, name: driverUniqueId };
}

/**
 * Get the driver for a given position.
 * @param {Object} position - Traccar position object
 * @param {Object} driversMap - Redux drivers.items
 * @returns {{ id: number|null, name: string|null }}
 */
export function getDriverForPosition(position, driversMap) {
  const uid = position?.attributes?.driverUniqueId;
  return resolveDriver(uid, driversMap);
}
